// extracted by mini-css-extract-plugin
export default {"container":"GalleryBlock_container__FxBXm","empty":"GalleryBlock_empty__3c8ry"};